import { useStoreTheme } from '../../../store';
import { useEffect } from 'react';

export default function PreviewSidebar() {
    const { previewSidebar, handlePreviewSidebar } = useStoreTheme();

    return (
        <div className={`h-full bg-gray-100 shadow-lg transition-all duration-300 ease-in-out overflow-hidden ${previewSidebar ? 'w-96' : 'w-0'}`}>
            <div className={`w-96 ${previewSidebar ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300 flex flex-col h-full`}>
                <div className="flex justify-between items-center px-6 py-5 bg-gray-100">
                    <h2 className="text-xl font-semibold">Preview</h2>

                    <button
                        onClick={handlePreviewSidebar}
                        className="w-8 h-8 flex items-center justify-center bg-white rounded-full hover:bg-gray-300">
                        ✕
                    </button>
                </div>

                <div className="flex-1 overflow-hidden">
                    <img
                        src="/icons/i-phone-13-mini-20.svg"
                        alt="Phone preview"
                        className="w-full h-full object-contain"
                    />
                </div>
            </div>
        </div>
    );
}
